import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { ChipModule } from '@libs/src/chip/chip.module';
import { TtcSegmentedModule } from '@libs/src/ttc-segmented/ttc-segmented.module';
import { GroupMatchExclusionsFormModule } from '@main-client/src/app/group-match-exclusions-form/group-match-exclusions-form.module';
import { MatchExclusionsDisplayModule } from '@main-client/src/app/match-exclusions-display/match-exclusions-display.module';
import { GetCustomRoleFromProgramRolesPipeModule } from '@main-client/src/app/pipes/get-custom-role-from-program-roles/get-custom-role-from-program-roles-pipe.module';

import { ProgramParticipantPreferencesEditDrawerService } from '@main-client/src/app/program-participant-preferences/program-participant-preferences-edit-drawer/program-participant-preferences-edit-drawer.service';

import { ProgramParticipantPreferencesFormComponent } from './program-participant-preferences-form/program-participant-preferences-form.component';
import { ProgramParticipantPreferencesComponent } from './program-participant-preferences.component';
import { ProgramParticipantPreferencesEditDrawerComponent } from '@main-client/src/app/program-participant-preferences/program-participant-preferences-edit-drawer/program-participant-preferences-edit-drawer.component';

import { AccountFullNamePipeModule } from '../pipes/account-full-name-pipe/account-full-name-pipe.module';
import { FindPipeModule } from '../pipes/find-pipe/find-pipe.module';

@NgModule({
  declarations: [
    ProgramParticipantPreferencesComponent,
    ProgramParticipantPreferencesEditDrawerComponent,
    ProgramParticipantPreferencesFormComponent,
  ],
  exports: [
    ProgramParticipantPreferencesComponent,
    ProgramParticipantPreferencesEditDrawerComponent,
    ProgramParticipantPreferencesFormComponent,
  ],
  imports: [
    AccountFullNamePipeModule,
    ChipModule,
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    FindPipeModule,
    MatchExclusionsDisplayModule,
    MatIconModule,
    NzButtonModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzRadioModule,
    NzSelectModule,
    ReactiveFormsModule,
    GroupMatchExclusionsFormModule,
    MatButtonModule,
    GetCustomRoleFromProgramRolesPipeModule,
    TtcSegmentedModule,
  ],
  providers: [ProgramParticipantPreferencesEditDrawerService],
})
export class ProgramParticipantPreferencesModule {}
